import { type CSSProperties } from 'react';
import { Modal } from '@helios/ui/overlay';
import { Button } from '@helios/ui/button';
import { NavIcon } from '../../shell/shared';

// Placeholder "Send Email" affordance for PO/DO detail drawers.
// The action is intentionally non-functional in v1 — the modal exists so
// users can discover the capability is planned and provide feedback. A
// future PRD will wire it up to a real supplier-email pipeline.

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** "Purchase Order" / "Delivery Order" — drives the body copy. */
  documentLabel: string;
  /** PO/DO number for the body copy, when known. */
  documentNumber?: string | null;
  portalStyle?: CSSProperties;
}

export function SendEmailComingSoonModal({
  open,
  onOpenChange,
  documentLabel,
  documentNumber,
  portalStyle,
}: Props) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="Send Email · Coming Soon"
      maxWidth={420}
      portalStyle={portalStyle}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <Button variant="gradient" size="md" onClick={() => onOpenChange(false)}>
            Got it
          </Button>
        </div>
      }
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'var(--sp-3)',
          padding: 'var(--sp-5) var(--sp-5) var(--sp-3)',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 'var(--radius-full)',
            background: '#eef2ff',
            color: '#4338ca',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <NavIcon name="mail" />
        </div>
        <div
          style={{
            fontSize: 'var(--font-size-base)',
            fontWeight: 'var(--font-weight-semi)',
            color: 'var(--text)',
          }}
        >
          Emailing this {documentLabel.toLowerCase()} is coming soon.
        </div>
        <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--text-muted)' }}>
          {documentNumber
            ? `We'll be able to send ${documentNumber} directly to the supplier from here in a future update.`
            : `We'll be able to send this ${documentLabel.toLowerCase()} directly to the supplier from here in a future update.`}
        </div>
      </div>
    </Modal>
  );
}
